import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow, Chip } from '@mui/material';
import { Autocomplete, TextField, IconButton } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const DocumentTemplateSignatureBookmarkOptionListItemComponent = ({
  documentTemplateXoptionBookmark,
  index,
  validation,
  onDelete,
  optionSources,
  handlePropertyChanged,
  handleLookupPropertyChanged
}) => {
  const [t] = useTranslation();

  return (
    <TableRow>
      <TableCell>
        <TextField
          fullWidth
          value={documentTemplateXoptionBookmark.bookmarkName || ''}
          error={!isValid(validation[index].bookmarkName)}
          helperText={getErrors(validation[index].bookmarkName)}
          onChange={event => handlePropertyChanged('bookmarkName', event)}
        />
      </TableCell>
      <TableCell>
        <Autocomplete
          fullWidth
          value={documentTemplateXoptionBookmark.dataSource}
          options={optionSources}
          onChange={event => handleLookupPropertyChanged('dataSource', event)}
          labelKey={'name'}
          valueKey={'id'}
          simpleValue={true}
          isClearable={true}
          isSearchable={true}
          error={!isValid(validation[index].dataSource)}
          helperText={getErrors(validation[index].dataSource)}
        />
      </TableCell>
      <TableCell>
        {documentTemplateXoptionBookmark.generatedBookmarks &&
          documentTemplateXoptionBookmark.generatedBookmarks.map((item, idx) => {
            return <Chip color='primary' size='small' key={idx} label={item} />;
          })}
      </TableCell>
      <TableCell>
        <IconButton type='delete' fontSize='medium' color='transparent' tooltip={t('Tooltips.Delete')} onClick={() => onDelete(index)} />
      </TableCell>
    </TableRow>
  );
};

DocumentTemplateSignatureBookmarkOptionListItemComponent.propTypes = {
  index: PropTypes.number.isRequired,
  validation: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
  handlePropertyChanged: PropTypes.func.isRequired,
  handleLookupPropertyChanged: PropTypes.func.isRequired,
  optionSources: PropTypes.array.isRequired,
  documentTemplateXoptionBookmark: PropTypes.object.isRequired
};

export default DocumentTemplateSignatureBookmarkOptionListItemComponent;
